$.extend({
  getUrlVars: function() {
    let vars = [],
      hash;
    let hashes = window.location.href
      .slice(window.location.href.indexOf('?') + 1)
      .split('&');
    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function(name) {
    return $.getUrlVars()[name];
  },
});
let HandleUrlVars = function() {
  // console.log('HandleUrlVars');
  let returnObj = {
    pOk: false,
    pId: null,
  };
  let pId = $.getUrlVar('pid');
  if (pId && parseInt(pId)) {
    returnObj.pOk = true;
    returnObj.pId = parseInt(pId);
  }
  return returnObj;
};
export default HandleUrlVars;
